/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddPersonExperienceInput
 */
export interface AddPersonExperienceInput {
    /**
     * 
     * @type {string}
     * @memberof AddPersonExperienceInput
     */
    'company_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddPersonExperienceInput
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddPersonExperienceInput
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddPersonExperienceInput
     */
    'end_date'?: string;
    /**
     * Is this the current role
     * @type {boolean}
     * @memberof AddPersonExperienceInput
     */
    'is_current'?: boolean;
    /**
     * Full PDL experience object
     * @type {object}
     * @memberof AddPersonExperienceInput
     */
    'raw'?: object;
}
/**
 * 
 * @export
 * @interface AssignProfileTagInput
 */
export interface AssignProfileTagInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof AssignProfileTagInput
     */
    'canonical_tag_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof AssignProfileTagInput
     */
    'user_id': string;
}
/**
 * 
 * @export
 * @interface BlockedUser
 */
export interface BlockedUser {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof BlockedUser
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof BlockedUser
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof BlockedUser
     */
    'blocked_user_id': string;
    /**
     * 
     * @type {boolean}
     * @memberof BlockedUser
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface BlockedUserInput
 */
export interface BlockedUserInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof BlockedUserInput
     */
    'blocked_user_id': string;
}
/**
 * Paginator for blocked users that generates the correct pagination links for the /users/{user_id}/blocks/ endpoint.
 * @export
 * @interface BlockedUsersPaginatorBlockedUser
 */
export interface BlockedUsersPaginatorBlockedUser {
    /**
     * 
     * @type {number}
     * @memberof BlockedUsersPaginatorBlockedUser
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof BlockedUsersPaginatorBlockedUser
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof BlockedUsersPaginatorBlockedUser
     */
    'limit': number;
    /**
     * 
     * @type {Array<BlockedUser>}
     * @memberof BlockedUsersPaginatorBlockedUser
     */
    'results': Array<BlockedUser>;
    /**
     * 
     * @type {string}
     * @memberof BlockedUsersPaginatorBlockedUser
     */
    'next'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockedUsersPaginatorBlockedUser
     */
    'previous'?: string;
}
/**
 * 
 * @export
 * @interface BulkCreateProfilesInput
 */
export interface BulkCreateProfilesInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkCreateProfilesInput
     */
    'user_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface BulkGetCommunitiesInput
 */
export interface BulkGetCommunitiesInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkGetCommunitiesInput
     */
    'community_ids': Array<string>;
    /**
     * 
     * @type {CommunityType}
     * @memberof BulkGetCommunitiesInput
     */
    'community_type'?: CommunityType;
}


/**
 * 
 * @export
 * @interface BulkGetProfilesInput
 */
export interface BulkGetProfilesInput {
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkGetProfilesInput
     */
    'user_ids': Array<string>;
}
/**
 * Output model for CanonicalProfileTag
 * @export
 * @interface CanonicalProfileTagOutput
 */
export interface CanonicalProfileTagOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CanonicalProfileTagOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CanonicalProfileTagOutput
     */
    'community_id': string;
    /**
     * 
     * @type {string}
     * @memberof CanonicalProfileTagOutput
     */
    'tag_name': string;
    /**
     * 
     * @type {string}
     * @memberof CanonicalProfileTagOutput
     */
    'description'?: string;
}
/**
 * Full community schema with relationships
 * @export
 * @interface Community
 */
export interface Community {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Community
     */
    'id'?: string;
    /**
     * Human-friendly community name
     * @type {string}
     * @memberof Community
     */
    'name': string;
    /**
     * Unique URL-safe slug for community identification
     * @type {string}
     * @memberof Community
     */
    'slug': string;
    /**
     * 
     * @type {CommunityType}
     * @memberof Community
     */
    'community_type'?: CommunityType;
    /**
     * 
     * @type {string}
     * @memberof Community
     */
    'headline'?: string;
    /**
     * 
     * @type {string}
     * @memberof Community
     */
    'bio'?: string;
    /**
     * 
     * @type {string}
     * @memberof Community
     */
    'created_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Community
     */
    'modified_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Community
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {CommunityLinks}
     * @memberof Community
     */
    'links'?: CommunityLinks;
    /**
     * 
     * @type {CommunityPhoto}
     * @memberof Community
     */
    'photos'?: CommunityPhoto;
    /**
     * 
     * @type {CommunityVideo}
     * @memberof Community
     */
    'videos'?: CommunityVideo;
}


/**
 * Output model for successful community creation
 * @export
 * @interface CommunityCreatedOutput
 */
export interface CommunityCreatedOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityCreatedOutput
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityCreatedOutput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityCreatedOutput
     */
    'slug'?: string;
    /**
     * 
     * @type {CommunityType}
     * @memberof CommunityCreatedOutput
     */
    'community_type'?: CommunityType;
    /**
     * 
     * @type {string}
     * @memberof CommunityCreatedOutput
     */
    'headline'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityCreatedOutput
     */
    'bio'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityCreatedOutput
     */
    'is_active'?: boolean;
}


/**
 * Output model for successful community deletion
 * @export
 * @interface CommunityDeletedOutput
 */
export interface CommunityDeletedOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityDeletedOutput
     */
    'community_id': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityDeletedOutput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityDeletedOutput
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityDeletedOutput
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface CommunityLinks
 */
export interface CommunityLinks {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityLinks
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityLinks
     */
    'community_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityLinks
     */
    'linkedin'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityLinks
     */
    'github'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityLinks
     */
    'x'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityLinks
     */
    'website'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityLinks
     */
    'is_active'?: boolean;
}
/**
 * Output model for community metadata
 * @export
 * @interface CommunityMetaOutput
 */
export interface CommunityMetaOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityMetaOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityMetaOutput
     */
    'community_id': string;
    /**
     * 
     * @type {CommunitySize}
     * @memberof CommunityMetaOutput
     */
    'community_size'?: CommunitySize;
    /**
     * 
     * @type {Array<FundingSource>}
     * @memberof CommunityMetaOutput
     */
    'funding_source'?: Array<FundingSource>;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityMetaOutput
     */
    'is_active'?: boolean;
}


/**
 * 
 * @export
 * @interface CommunityPhoto
 */
export interface CommunityPhoto {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityPhoto
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityPhoto
     */
    'community_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPhoto
     */
    'thumbnail_small'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPhoto
     */
    'thumbnail_large'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPhoto
     */
    'small'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPhoto
     */
    'medium'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityPhoto
     */
    'large'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityPhoto
     */
    'is_active'?: boolean;
}
/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const CommunitySize = {
    _0500: '0-500',
    _5011500: '501-1500',
    _15015000: '1501-5000',
    _5001: '5001+'
} as const;

export type CommunitySize = typeof CommunitySize[keyof typeof CommunitySize];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const CommunityType = {
    Organization: 'organization',
    Event: 'event'
} as const;

export type CommunityType = typeof CommunityType[keyof typeof CommunityType];


/**
 * Output model for successful community update
 * @export
 * @interface CommunityUpdatedOutput
 */
export interface CommunityUpdatedOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityUpdatedOutput
     */
    'community_id': string;
    /**
     * 
     * @type {string}
     * @memberof CommunityUpdatedOutput
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityUpdatedOutput
     */
    'slug'?: string;
    /**
     * 
     * @type {CommunityType}
     * @memberof CommunityUpdatedOutput
     */
    'community_type'?: CommunityType;
    /**
     * 
     * @type {string}
     * @memberof CommunityUpdatedOutput
     */
    'headline'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityUpdatedOutput
     */
    'bio'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityUpdatedOutput
     */
    'is_active'?: boolean;
}


/**
 * 
 * @export
 * @interface CommunityVideo
 */
export interface CommunityVideo {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityVideo
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CommunityVideo
     */
    'community_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityVideo
     */
    'thumbnail_small'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityVideo
     */
    'thumbnail_large'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityVideo
     */
    'small'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityVideo
     */
    'medium'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityVideo
     */
    'large'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityVideo
     */
    'x_large'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunityVideo
     */
    'original'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunityVideo
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateCanonicalProfileTagInput
 */
export interface CreateCanonicalProfileTagInput {
    /**
     * Tag name
     * @type {string}
     * @memberof CreateCanonicalProfileTagInput
     */
    'tag_name': string;
    /**
     * Optional tag description
     * @type {string}
     * @memberof CreateCanonicalProfileTagInput
     */
    'description'?: string;
}
/**
 * Input for creating a community with required human-friendly name
 * @export
 * @interface CreateCommunityInput
 */
export interface CreateCommunityInput {
    /**
     * Human-friendly community name
     * @type {string}
     * @memberof CreateCommunityInput
     */
    'name': string;
    /**
     * URL-safe slug (auto-generated from name if not provided)
     * @type {string}
     * @memberof CreateCommunityInput
     */
    'slug'?: string;
    /**
     * 
     * @type {CommunityType}
     * @memberof CreateCommunityInput
     */
    'community_type'?: CommunityType;
    /**
     * 
     * @type {string}
     * @memberof CreateCommunityInput
     */
    'headline'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCommunityInput
     */
    'bio'?: string;
}


/**
 * Input for creating community metadata
 * @export
 * @interface CreateCommunityMetaInput
 */
export interface CreateCommunityMetaInput {
    /**
     * 
     * @type {CommunitySize}
     * @memberof CreateCommunityMetaInput
     */
    'community_size'?: CommunitySize;
    /**
     * List of funding sources for the community
     * @type {Array<FundingSource>}
     * @memberof CreateCommunityMetaInput
     */
    'funding_source'?: Array<FundingSource>;
}


/**
 * 
 * @export
 * @interface CreatePersonInput
 */
export interface CreatePersonInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreatePersonInput
     */
    'user_id'?: string;
    /**
     * External enrichment provider identifier
     * @type {string}
     * @memberof CreatePersonInput
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonInput
     */
    'linkedin_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonInput
     */
    'github_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonInput
     */
    'twitter_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonInput
     */
    'sex'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePersonInput
     */
    'birth_year'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonInput
     */
    'birth_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonInput
     */
    'location_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonInput
     */
    'location_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePersonInput
     */
    'location_country'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreatePersonInput
     */
    'org_id'?: string;
}
/**
 * 
 * @export
 * @interface CreateProfileInput
 */
export interface CreateProfileInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof CreateProfileInput
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfileInput
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfileInput
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfileInput
     */
    'headline'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateProfileInput
     */
    'bio'?: string;
    /**
     * 
     * @type {GenderPronouns}
     * @memberof CreateProfileInput
     */
    'pronouns'?: GenderPronouns;
}


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const FundingSource = {
    Grants: 'grants',
    MarketingSponsorships: 'marketing_sponsorships',
    ImpactSponsorships: 'impact_sponsorships',
    TicketSales: 'ticket_sales',
    LeadGeneration: 'lead_generation'
} as const;

export type FundingSource = typeof FundingSource[keyof typeof FundingSource];


/**
 * An enumeration.
 * @export
 * @enum {string}
 */

export const GenderPronouns = {
    HeHim: 'he/him',
    SheHer: 'she/her',
    TheyThem: 'they/them'
} as const;

export type GenderPronouns = typeof GenderPronouns[keyof typeof GenderPronouns];


/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * Output model for the is_user_blocked endpoint
 * @export
 * @interface IsBlockedOutput
 */
export interface IsBlockedOutput {
    /**
     * 
     * @type {boolean}
     * @memberof IsBlockedOutput
     */
    'is_blocked': boolean;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IsBlockedOutput
     */
    'user_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof IsBlockedOutput
     */
    'blocked_user_id': string;
}
/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * Generic paginator with ORM support for any database-backed paginated results. Can be used for any entity type that requires pagination with ORM compatibility.  Examples: - Profile search results - Blocked users - Membership types - Any other paginated database results
 * @export
 * @interface OrmPaginatorCommunity
 */
export interface OrmPaginatorCommunity {
    /**
     * 
     * @type {number}
     * @memberof OrmPaginatorCommunity
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof OrmPaginatorCommunity
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof OrmPaginatorCommunity
     */
    'limit': number;
    /**
     * 
     * @type {Array<Community>}
     * @memberof OrmPaginatorCommunity
     */
    'results': Array<Community>;
    /**
     * 
     * @type {string}
     * @memberof OrmPaginatorCommunity
     */
    'next'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrmPaginatorCommunity
     */
    'previous'?: string;
}
/**
 * Output model for PersonExperience
 * @export
 * @interface PersonExperienceOutput
 */
export interface PersonExperienceOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PersonExperienceOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PersonExperienceOutput
     */
    'person_id': string;
    /**
     * 
     * @type {string}
     * @memberof PersonExperienceOutput
     */
    'company_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonExperienceOutput
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonExperienceOutput
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonExperienceOutput
     */
    'end_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PersonExperienceOutput
     */
    'is_current'?: boolean;
}
/**
 * Output model for Person
 * @export
 * @interface PersonOutput
 */
export interface PersonOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PersonOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PersonOutput
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOutput
     */
    'external_id': string;
    /**
     * 
     * @type {string}
     * @memberof PersonOutput
     */
    'linkedin_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOutput
     */
    'github_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOutput
     */
    'twitter_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOutput
     */
    'sex'?: string;
    /**
     * 
     * @type {number}
     * @memberof PersonOutput
     */
    'birth_year'?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonOutput
     */
    'birth_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOutput
     */
    'location_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOutput
     */
    'location_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonOutput
     */
    'location_country'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof PersonOutput
     */
    'org_id'?: string;
    /**
     * 
     * @type {Array<PersonExperienceOutput>}
     * @memberof PersonOutput
     */
    'experiences'?: Array<PersonExperienceOutput>;
}
/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof Profile
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'headline'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'bio'?: string;
    /**
     * 
     * @type {GenderPronouns}
     * @memberof Profile
     */
    'pronouns'?: GenderPronouns;
    /**
     * 
     * @type {ProfileLinks}
     * @memberof Profile
     */
    'links'?: ProfileLinks;
    /**
     * 
     * @type {ProfilePhoto}
     * @memberof Profile
     */
    'photos'?: ProfilePhoto;
    /**
     * 
     * @type {ProfileVideo}
     * @memberof Profile
     */
    'videos'?: ProfileVideo;
    /**
     * 
     * @type {Array<BlockedUser>}
     * @memberof Profile
     */
    'blocked_users'?: Array<BlockedUser>;
    /**
     * 
     * @type {boolean}
     * @memberof Profile
     */
    'is_active'?: boolean;
}


/**
 * 
 * @export
 * @interface ProfileLinks
 */
export interface ProfileLinks {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ProfileLinks
     */
    'id'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ProfileLinks
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileLinks
     */
    'linkedin'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileLinks
     */
    'github'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileLinks
     */
    'x'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileLinks
     */
    'website'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileLinks
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface ProfilePhoto
 */
export interface ProfilePhoto {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ProfilePhoto
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProfilePhoto
     */
    'thumbnail_small'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilePhoto
     */
    'thumbnail_large'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilePhoto
     */
    'small'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilePhoto
     */
    'medium'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfilePhoto
     */
    'large'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfilePhoto
     */
    'is_active'?: boolean;
}
/**
 * Custom paginator for profile search results that generates the correct pagination links for the /profiles/search/ endpoint.
 * @export
 * @interface ProfileSearchPaginatorProfile
 */
export interface ProfileSearchPaginatorProfile {
    /**
     * 
     * @type {number}
     * @memberof ProfileSearchPaginatorProfile
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ProfileSearchPaginatorProfile
     */
    'offset': number;
    /**
     * 
     * @type {number}
     * @memberof ProfileSearchPaginatorProfile
     */
    'limit': number;
    /**
     * 
     * @type {Array<Profile>}
     * @memberof ProfileSearchPaginatorProfile
     */
    'results': Array<Profile>;
    /**
     * 
     * @type {string}
     * @memberof ProfileSearchPaginatorProfile
     */
    'next'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileSearchPaginatorProfile
     */
    'previous'?: string;
}
/**
 * Output model for ProfileTag
 * @export
 * @interface ProfileTagOutput
 */
export interface ProfileTagOutput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ProfileTagOutput
     */
    'id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ProfileTagOutput
     */
    'canonical_tag_id': string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ProfileTagOutput
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileTagOutput
     */
    'tag_name': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileTagOutput
     */
    'tag_description'?: string;
}
/**
 * 
 * @export
 * @interface ProfileVideo
 */
export interface ProfileVideo {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof ProfileVideo
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileVideo
     */
    'thumbnail_small'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileVideo
     */
    'thumbnail_large'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileVideo
     */
    'small'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileVideo
     */
    'medium'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileVideo
     */
    'large'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileVideo
     */
    'x_large'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileVideo
     */
    'original'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileVideo
     */
    'is_active'?: boolean;
}
/**
 * 
 * @export
 * @interface SearchProfilesInput
 */
export interface SearchProfilesInput {
    /**
     * Search term for matching against first and last names (minimum 3 characters)
     * @type {string}
     * @memberof SearchProfilesInput
     */
    'query': string;
    /**
     * Maximum number of results to return
     * @type {number}
     * @memberof SearchProfilesInput
     */
    'limit'?: number;
    /**
     * Offset for pagination
     * @type {number}
     * @memberof SearchProfilesInput
     */
    'offset'?: number;
}
/**
 * 
 * @export
 * @interface UpdateCanonicalProfileTagInput
 */
export interface UpdateCanonicalProfileTagInput {
    /**
     * Tag name
     * @type {string}
     * @memberof UpdateCanonicalProfileTagInput
     */
    'tag_name'?: string;
    /**
     * Optional tag description
     * @type {string}
     * @memberof UpdateCanonicalProfileTagInput
     */
    'description'?: string;
}
/**
 * Input for updating a community with optional human-friendly name
 * @export
 * @interface UpdateCommunityInput
 */
export interface UpdateCommunityInput {
    /**
     * Human-friendly community name
     * @type {string}
     * @memberof UpdateCommunityInput
     */
    'name'?: string;
    /**
     * URL-safe slug (auto-generated from name if name provided and slug not specified)
     * @type {string}
     * @memberof UpdateCommunityInput
     */
    'slug'?: string;
    /**
     * 
     * @type {CommunityType}
     * @memberof UpdateCommunityInput
     */
    'community_type'?: CommunityType;
    /**
     * 
     * @type {string}
     * @memberof UpdateCommunityInput
     */
    'headline'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCommunityInput
     */
    'bio'?: string;
}


/**
 * 
 * @export
 * @interface UpdateCommunityLinksInput
 */
export interface UpdateCommunityLinksInput {
    /**
     * LinkedIn company page URL
     * @type {string}
     * @memberof UpdateCommunityLinksInput
     */
    'linkedin'?: string;
    /**
     * GitHub organization or user profile URL
     * @type {string}
     * @memberof UpdateCommunityLinksInput
     */
    'github'?: string;
    /**
     * X (formerly Twitter) profile URL
     * @type {string}
     * @memberof UpdateCommunityLinksInput
     */
    'x'?: string;
    /**
     * Community website URL
     * @type {string}
     * @memberof UpdateCommunityLinksInput
     */
    'website'?: string;
}
/**
 * 
 * @export
 * @interface UpdatePersonExperienceInput
 */
export interface UpdatePersonExperienceInput {
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonExperienceInput
     */
    'company_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonExperienceInput
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonExperienceInput
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonExperienceInput
     */
    'end_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePersonExperienceInput
     */
    'is_current'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof UpdatePersonExperienceInput
     */
    'raw'?: object;
}
/**
 * 
 * @export
 * @interface UpdatePersonInput
 */
export interface UpdatePersonInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'external_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'linkedin_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'github_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'twitter_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'sex'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdatePersonInput
     */
    'birth_year'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'birth_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'location_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'location_region'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'location_country'?: string;
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdatePersonInput
     */
    'org_id'?: string;
}
/**
 * 
 * @export
 * @interface UpdateProfileInput
 */
export interface UpdateProfileInput {
    /**
     * A unique identifier (UUID) in hexadecimal format
     * @type {string}
     * @memberof UpdateProfileInput
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileInput
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileInput
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileInput
     */
    'headline'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileInput
     */
    'bio'?: string;
    /**
     * 
     * @type {GenderPronouns}
     * @memberof UpdateProfileInput
     */
    'pronouns'?: GenderPronouns;
}


/**
 * 
 * @export
 * @interface UpdateProfileLinksInput
 */
export interface UpdateProfileLinksInput {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileLinksInput
     */
    'linkedin'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileLinksInput
     */
    'github'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileLinksInput
     */
    'x'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileLinksInput
     */
    'website'?: string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}

/**
 * CommunitiesApi - axios parameter creator
 * @export
 */
export const CommunitiesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get multiple communities by their IDs
         * @summary Bulk Get Communities
         * @param {BulkGetCommunitiesInput} bulkGetCommunitiesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetCommunitiesCommunitiesBulkPost: async (bulkGetCommunitiesInput: BulkGetCommunitiesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetCommunitiesInput' is not null or undefined
            assertParamExists('bulkGetCommunitiesCommunitiesBulkPost', 'bulkGetCommunitiesInput', bulkGetCommunitiesInput)
            const localVarPath = `/communities/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetCommunitiesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new community
         * @summary Create Community
         * @param {CreateCommunityInput} createCommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommunityCommunitiesPost: async (createCommunityInput: CreateCommunityInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCommunityInput' is not null or undefined
            assertParamExists('createCommunityCommunitiesPost', 'createCommunityInput', createCommunityInput)
            const localVarPath = `/communities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommunityInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create community metadata (community owner only)
         * @summary Create Community Meta
         * @param {string} communityId 
         * @param {CreateCommunityMetaInput} createCommunityMetaInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommunityMetaCommunitiesCommunityIdMetaPost: async (communityId: string, createCommunityMetaInput: CreateCommunityMetaInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createCommunityMetaCommunitiesCommunityIdMetaPost', 'communityId', communityId)
            // verify required parameter 'createCommunityMetaInput' is not null or undefined
            assertParamExists('createCommunityMetaCommunitiesCommunityIdMetaPost', 'createCommunityMetaInput', createCommunityMetaInput)
            const localVarPath = `/communities/{community_id}/meta/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCommunityMetaInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a community (soft delete)
         * @summary Delete Community
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommunityCommunitiesCommunityIdDelete: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deleteCommunityCommunitiesCommunityIdDelete', 'communityId', communityId)
            const localVarPath = `/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete community metadata (admin only)
         * @summary Delete Community Meta
         * @param {string} communityId 
         * @param {string} metaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete: async (communityId: string, metaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete', 'communityId', communityId)
            // verify required parameter 'metaId' is not null or undefined
            assertParamExists('deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete', 'metaId', metaId)
            const localVarPath = `/communities/{community_id}/meta/{meta_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"meta_id"}}`, encodeURIComponent(String(metaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all communities with pagination
         * @summary Get Communities
         * @param {CommunityType} [communityType] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunitiesCommunitiesGet: async (communityType?: CommunityType, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communities/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (communityType !== undefined) {
                localVarQueryParameter['community_type'] = communityType;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a community by slug
         * @summary Get Community By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityBySlugCommunitiesSlugSlugGet: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getCommunityBySlugCommunitiesSlugSlugGet', 'slug', slug)
            const localVarPath = `/communities/slug/{slug}/`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a community by ID
         * @summary Get Community
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityCommunitiesCommunityIdGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getCommunityCommunitiesCommunityIdGet', 'communityId', communityId)
            const localVarPath = `/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get community metadata (admin only)
         * @summary Get Community Meta
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityMetaCommunitiesCommunityIdMetaGet: async (communityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getCommunityMetaCommunitiesCommunityIdMetaGet', 'communityId', communityId)
            const localVarPath = `/communities/{community_id}/meta/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all community metadata (admin only)
         * @summary List Community Metas
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommunityMetasCommunitiesMetaGet: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communities/meta/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search communities by name, headline, or bio
         * @summary Search Communities
         * @param {string} query 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCommunitiesCommunitiesSearchGet: async (query: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchCommunitiesCommunitiesSearchGet', 'query', query)
            const localVarPath = `/communities/search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a community
         * @summary Update Community
         * @param {string} communityId 
         * @param {UpdateCommunityInput} updateCommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunityCommunitiesCommunityIdPut: async (communityId: string, updateCommunityInput: UpdateCommunityInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateCommunityCommunitiesCommunityIdPut', 'communityId', communityId)
            // verify required parameter 'updateCommunityInput' is not null or undefined
            assertParamExists('updateCommunityCommunitiesCommunityIdPut', 'updateCommunityInput', updateCommunityInput)
            const localVarPath = `/communities/{community_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommunityInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update community social links
         * @summary Update Community Links
         * @param {string} communityId 
         * @param {UpdateCommunityLinksInput} updateCommunityLinksInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunityLinksCommunitiesCommunityIdLinksPut: async (communityId: string, updateCommunityLinksInput: UpdateCommunityLinksInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateCommunityLinksCommunitiesCommunityIdLinksPut', 'communityId', communityId)
            // verify required parameter 'updateCommunityLinksInput' is not null or undefined
            assertParamExists('updateCommunityLinksCommunitiesCommunityIdLinksPut', 'updateCommunityLinksInput', updateCommunityLinksInput)
            const localVarPath = `/communities/{community_id}/links/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommunityLinksInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update community photo
         * @summary Update Community Photo
         * @param {string} communityId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunityPhotoCommunitiesCommunityIdPhotoPut: async (communityId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateCommunityPhotoCommunitiesCommunityIdPhotoPut', 'communityId', communityId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('updateCommunityPhotoCommunitiesCommunityIdPhotoPut', 'file', file)
            const localVarPath = `/communities/{community_id}/photo/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update community video
         * @summary Update Community Video
         * @param {string} communityId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunityVideoCommunitiesCommunityIdVideoPut: async (communityId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateCommunityVideoCommunitiesCommunityIdVideoPut', 'communityId', communityId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('updateCommunityVideoCommunitiesCommunityIdVideoPut', 'file', file)
            const localVarPath = `/communities/{community_id}/video/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunitiesApi - functional programming interface
 * @export
 */
export const CommunitiesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunitiesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get multiple communities by their IDs
         * @summary Bulk Get Communities
         * @param {BulkGetCommunitiesInput} bulkGetCommunitiesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetCommunitiesCommunitiesBulkPost(bulkGetCommunitiesInput: BulkGetCommunitiesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Community>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetCommunitiesCommunitiesBulkPost(bulkGetCommunitiesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.bulkGetCommunitiesCommunitiesBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new community
         * @summary Create Community
         * @param {CreateCommunityInput} createCommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommunityCommunitiesPost(createCommunityInput: CreateCommunityInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityCreatedOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommunityCommunitiesPost(createCommunityInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.createCommunityCommunitiesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create community metadata (community owner only)
         * @summary Create Community Meta
         * @param {string} communityId 
         * @param {CreateCommunityMetaInput} createCommunityMetaInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCommunityMetaCommunitiesCommunityIdMetaPost(communityId: string, createCommunityMetaInput: CreateCommunityMetaInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCommunityMetaCommunitiesCommunityIdMetaPost(communityId, createCommunityMetaInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.createCommunityMetaCommunitiesCommunityIdMetaPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete a community (soft delete)
         * @summary Delete Community
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommunityCommunitiesCommunityIdDelete(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityDeletedOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommunityCommunitiesCommunityIdDelete(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.deleteCommunityCommunitiesCommunityIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Delete community metadata (admin only)
         * @summary Delete Community Meta
         * @param {string} communityId 
         * @param {string} metaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete(communityId: string, metaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete(communityId, metaId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all communities with pagination
         * @summary Get Communities
         * @param {CommunityType} [communityType] 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunitiesCommunitiesGet(communityType?: CommunityType, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrmPaginatorCommunity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunitiesCommunitiesGet(communityType, limit, offset, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.getCommunitiesCommunitiesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a community by slug
         * @summary Get Community By Slug
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunityBySlugCommunitiesSlugSlugGet(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Community>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunityBySlugCommunitiesSlugSlugGet(slug, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.getCommunityBySlugCommunitiesSlugSlugGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get a community by ID
         * @summary Get Community
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunityCommunitiesCommunityIdGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Community>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunityCommunitiesCommunityIdGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.getCommunityCommunitiesCommunityIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get community metadata (admin only)
         * @summary Get Community Meta
         * @param {string} communityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunityMetaCommunitiesCommunityIdMetaGet(communityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityMetaOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunityMetaCommunitiesCommunityIdMetaGet(communityId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.getCommunityMetaCommunitiesCommunityIdMetaGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * List all community metadata (admin only)
         * @summary List Community Metas
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCommunityMetasCommunitiesMetaGet(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommunityMetaOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCommunityMetasCommunitiesMetaGet(limit, offset, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.listCommunityMetasCommunitiesMetaGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Search communities by name, headline, or bio
         * @summary Search Communities
         * @param {string} query 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCommunitiesCommunitiesSearchGet(query: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrmPaginatorCommunity>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCommunitiesCommunitiesSearchGet(query, limit, offset, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.searchCommunitiesCommunitiesSearchGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a community
         * @summary Update Community
         * @param {string} communityId 
         * @param {UpdateCommunityInput} updateCommunityInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommunityCommunitiesCommunityIdPut(communityId: string, updateCommunityInput: UpdateCommunityInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunityUpdatedOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommunityCommunitiesCommunityIdPut(communityId, updateCommunityInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.updateCommunityCommunitiesCommunityIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update community social links
         * @summary Update Community Links
         * @param {string} communityId 
         * @param {UpdateCommunityLinksInput} updateCommunityLinksInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommunityLinksCommunitiesCommunityIdLinksPut(communityId: string, updateCommunityLinksInput: UpdateCommunityLinksInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommunityLinksCommunitiesCommunityIdLinksPut(communityId, updateCommunityLinksInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.updateCommunityLinksCommunitiesCommunityIdLinksPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update community photo
         * @summary Update Community Photo
         * @param {string} communityId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommunityPhotoCommunitiesCommunityIdPhotoPut(communityId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommunityPhotoCommunitiesCommunityIdPhotoPut(communityId, file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.updateCommunityPhotoCommunitiesCommunityIdPhotoPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update community video
         * @summary Update Community Video
         * @param {string} communityId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommunityVideoCommunitiesCommunityIdVideoPut(communityId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommunityVideoCommunitiesCommunityIdVideoPut(communityId, file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommunitiesApi.updateCommunityVideoCommunitiesCommunityIdVideoPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CommunitiesApi - factory interface
 * @export
 */
export const CommunitiesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunitiesApiFp(configuration)
    return {
        /**
         * Get multiple communities by their IDs
         * @summary Bulk Get Communities
         * @param {CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetCommunitiesCommunitiesBulkPost(requestParameters: CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Community>> {
            return localVarFp.bulkGetCommunitiesCommunitiesBulkPost(requestParameters.bulkGetCommunitiesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new community
         * @summary Create Community
         * @param {CommunitiesApiCreateCommunityCommunitiesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommunityCommunitiesPost(requestParameters: CommunitiesApiCreateCommunityCommunitiesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityCreatedOutput> {
            return localVarFp.createCommunityCommunitiesPost(requestParameters.createCommunityInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create community metadata (community owner only)
         * @summary Create Community Meta
         * @param {CommunitiesApiCreateCommunityMetaCommunitiesCommunityIdMetaPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCommunityMetaCommunitiesCommunityIdMetaPost(requestParameters: CommunitiesApiCreateCommunityMetaCommunitiesCommunityIdMetaPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createCommunityMetaCommunitiesCommunityIdMetaPost(requestParameters.communityId, requestParameters.createCommunityMetaInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a community (soft delete)
         * @summary Delete Community
         * @param {CommunitiesApiDeleteCommunityCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommunityCommunitiesCommunityIdDelete(requestParameters: CommunitiesApiDeleteCommunityCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityDeletedOutput> {
            return localVarFp.deleteCommunityCommunitiesCommunityIdDelete(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete community metadata (admin only)
         * @summary Delete Community Meta
         * @param {CommunitiesApiDeleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete(requestParameters: CommunitiesApiDeleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete(requestParameters.communityId, requestParameters.metaId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all communities with pagination
         * @summary Get Communities
         * @param {CommunitiesApiGetCommunitiesCommunitiesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunitiesCommunitiesGet(requestParameters: CommunitiesApiGetCommunitiesCommunitiesGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<OrmPaginatorCommunity> {
            return localVarFp.getCommunitiesCommunitiesGet(requestParameters.communityType, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a community by slug
         * @summary Get Community By Slug
         * @param {CommunitiesApiGetCommunityBySlugCommunitiesSlugSlugGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityBySlugCommunitiesSlugSlugGet(requestParameters: CommunitiesApiGetCommunityBySlugCommunitiesSlugSlugGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Community> {
            return localVarFp.getCommunityBySlugCommunitiesSlugSlugGet(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a community by ID
         * @summary Get Community
         * @param {CommunitiesApiGetCommunityCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityCommunitiesCommunityIdGet(requestParameters: CommunitiesApiGetCommunityCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Community> {
            return localVarFp.getCommunityCommunitiesCommunityIdGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get community metadata (admin only)
         * @summary Get Community Meta
         * @param {CommunitiesApiGetCommunityMetaCommunitiesCommunityIdMetaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunityMetaCommunitiesCommunityIdMetaGet(requestParameters: CommunitiesApiGetCommunityMetaCommunitiesCommunityIdMetaGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityMetaOutput> {
            return localVarFp.getCommunityMetaCommunitiesCommunityIdMetaGet(requestParameters.communityId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all community metadata (admin only)
         * @summary List Community Metas
         * @param {CommunitiesApiListCommunityMetasCommunitiesMetaGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCommunityMetasCommunitiesMetaGet(requestParameters: CommunitiesApiListCommunityMetasCommunitiesMetaGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CommunityMetaOutput>> {
            return localVarFp.listCommunityMetasCommunitiesMetaGet(requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Search communities by name, headline, or bio
         * @summary Search Communities
         * @param {CommunitiesApiSearchCommunitiesCommunitiesSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCommunitiesCommunitiesSearchGet(requestParameters: CommunitiesApiSearchCommunitiesCommunitiesSearchGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<OrmPaginatorCommunity> {
            return localVarFp.searchCommunitiesCommunitiesSearchGet(requestParameters.query, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a community
         * @summary Update Community
         * @param {CommunitiesApiUpdateCommunityCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunityCommunitiesCommunityIdPut(requestParameters: CommunitiesApiUpdateCommunityCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommunityUpdatedOutput> {
            return localVarFp.updateCommunityCommunitiesCommunityIdPut(requestParameters.communityId, requestParameters.updateCommunityInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update community social links
         * @summary Update Community Links
         * @param {CommunitiesApiUpdateCommunityLinksCommunitiesCommunityIdLinksPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunityLinksCommunitiesCommunityIdLinksPut(requestParameters: CommunitiesApiUpdateCommunityLinksCommunitiesCommunityIdLinksPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateCommunityLinksCommunitiesCommunityIdLinksPut(requestParameters.communityId, requestParameters.updateCommunityLinksInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update community photo
         * @summary Update Community Photo
         * @param {CommunitiesApiUpdateCommunityPhotoCommunitiesCommunityIdPhotoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunityPhotoCommunitiesCommunityIdPhotoPut(requestParameters: CommunitiesApiUpdateCommunityPhotoCommunitiesCommunityIdPhotoPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateCommunityPhotoCommunitiesCommunityIdPhotoPut(requestParameters.communityId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * Update community video
         * @summary Update Community Video
         * @param {CommunitiesApiUpdateCommunityVideoCommunitiesCommunityIdVideoPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunityVideoCommunitiesCommunityIdVideoPut(requestParameters: CommunitiesApiUpdateCommunityVideoCommunitiesCommunityIdVideoPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateCommunityVideoCommunitiesCommunityIdVideoPut(requestParameters.communityId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for bulkGetCommunitiesCommunitiesBulkPost operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest
 */
export interface CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest {
    /**
     * 
     * @type {BulkGetCommunitiesInput}
     * @memberof CommunitiesApiBulkGetCommunitiesCommunitiesBulkPost
     */
    readonly bulkGetCommunitiesInput: BulkGetCommunitiesInput
}

/**
 * Request parameters for createCommunityCommunitiesPost operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCreateCommunityCommunitiesPostRequest
 */
export interface CommunitiesApiCreateCommunityCommunitiesPostRequest {
    /**
     * 
     * @type {CreateCommunityInput}
     * @memberof CommunitiesApiCreateCommunityCommunitiesPost
     */
    readonly createCommunityInput: CreateCommunityInput
}

/**
 * Request parameters for createCommunityMetaCommunitiesCommunityIdMetaPost operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiCreateCommunityMetaCommunitiesCommunityIdMetaPostRequest
 */
export interface CommunitiesApiCreateCommunityMetaCommunitiesCommunityIdMetaPostRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiCreateCommunityMetaCommunitiesCommunityIdMetaPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateCommunityMetaInput}
     * @memberof CommunitiesApiCreateCommunityMetaCommunitiesCommunityIdMetaPost
     */
    readonly createCommunityMetaInput: CreateCommunityMetaInput
}

/**
 * Request parameters for deleteCommunityCommunitiesCommunityIdDelete operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiDeleteCommunityCommunitiesCommunityIdDeleteRequest
 */
export interface CommunitiesApiDeleteCommunityCommunitiesCommunityIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiDeleteCommunityCommunitiesCommunityIdDelete
     */
    readonly communityId: string
}

/**
 * Request parameters for deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiDeleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDeleteRequest
 */
export interface CommunitiesApiDeleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiDeleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiDeleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete
     */
    readonly metaId: string
}

/**
 * Request parameters for getCommunitiesCommunitiesGet operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiGetCommunitiesCommunitiesGetRequest
 */
export interface CommunitiesApiGetCommunitiesCommunitiesGetRequest {
    /**
     * 
     * @type {CommunityType}
     * @memberof CommunitiesApiGetCommunitiesCommunitiesGet
     */
    readonly communityType?: CommunityType

    /**
     * 
     * @type {number}
     * @memberof CommunitiesApiGetCommunitiesCommunitiesGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof CommunitiesApiGetCommunitiesCommunitiesGet
     */
    readonly offset?: number
}

/**
 * Request parameters for getCommunityBySlugCommunitiesSlugSlugGet operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiGetCommunityBySlugCommunitiesSlugSlugGetRequest
 */
export interface CommunitiesApiGetCommunityBySlugCommunitiesSlugSlugGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiGetCommunityBySlugCommunitiesSlugSlugGet
     */
    readonly slug: string
}

/**
 * Request parameters for getCommunityCommunitiesCommunityIdGet operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiGetCommunityCommunitiesCommunityIdGetRequest
 */
export interface CommunitiesApiGetCommunityCommunitiesCommunityIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiGetCommunityCommunitiesCommunityIdGet
     */
    readonly communityId: string
}

/**
 * Request parameters for getCommunityMetaCommunitiesCommunityIdMetaGet operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiGetCommunityMetaCommunitiesCommunityIdMetaGetRequest
 */
export interface CommunitiesApiGetCommunityMetaCommunitiesCommunityIdMetaGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiGetCommunityMetaCommunitiesCommunityIdMetaGet
     */
    readonly communityId: string
}

/**
 * Request parameters for listCommunityMetasCommunitiesMetaGet operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiListCommunityMetasCommunitiesMetaGetRequest
 */
export interface CommunitiesApiListCommunityMetasCommunitiesMetaGetRequest {
    /**
     * 
     * @type {number}
     * @memberof CommunitiesApiListCommunityMetasCommunitiesMetaGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof CommunitiesApiListCommunityMetasCommunitiesMetaGet
     */
    readonly offset?: number
}

/**
 * Request parameters for searchCommunitiesCommunitiesSearchGet operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiSearchCommunitiesCommunitiesSearchGetRequest
 */
export interface CommunitiesApiSearchCommunitiesCommunitiesSearchGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiSearchCommunitiesCommunitiesSearchGet
     */
    readonly query: string

    /**
     * 
     * @type {number}
     * @memberof CommunitiesApiSearchCommunitiesCommunitiesSearchGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof CommunitiesApiSearchCommunitiesCommunitiesSearchGet
     */
    readonly offset?: number
}

/**
 * Request parameters for updateCommunityCommunitiesCommunityIdPut operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiUpdateCommunityCommunitiesCommunityIdPutRequest
 */
export interface CommunitiesApiUpdateCommunityCommunitiesCommunityIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiUpdateCommunityCommunitiesCommunityIdPut
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdateCommunityInput}
     * @memberof CommunitiesApiUpdateCommunityCommunitiesCommunityIdPut
     */
    readonly updateCommunityInput: UpdateCommunityInput
}

/**
 * Request parameters for updateCommunityLinksCommunitiesCommunityIdLinksPut operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiUpdateCommunityLinksCommunitiesCommunityIdLinksPutRequest
 */
export interface CommunitiesApiUpdateCommunityLinksCommunitiesCommunityIdLinksPutRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiUpdateCommunityLinksCommunitiesCommunityIdLinksPut
     */
    readonly communityId: string

    /**
     * 
     * @type {UpdateCommunityLinksInput}
     * @memberof CommunitiesApiUpdateCommunityLinksCommunitiesCommunityIdLinksPut
     */
    readonly updateCommunityLinksInput: UpdateCommunityLinksInput
}

/**
 * Request parameters for updateCommunityPhotoCommunitiesCommunityIdPhotoPut operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiUpdateCommunityPhotoCommunitiesCommunityIdPhotoPutRequest
 */
export interface CommunitiesApiUpdateCommunityPhotoCommunitiesCommunityIdPhotoPutRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiUpdateCommunityPhotoCommunitiesCommunityIdPhotoPut
     */
    readonly communityId: string

    /**
     * 
     * @type {File}
     * @memberof CommunitiesApiUpdateCommunityPhotoCommunitiesCommunityIdPhotoPut
     */
    readonly file: File
}

/**
 * Request parameters for updateCommunityVideoCommunitiesCommunityIdVideoPut operation in CommunitiesApi.
 * @export
 * @interface CommunitiesApiUpdateCommunityVideoCommunitiesCommunityIdVideoPutRequest
 */
export interface CommunitiesApiUpdateCommunityVideoCommunitiesCommunityIdVideoPutRequest {
    /**
     * 
     * @type {string}
     * @memberof CommunitiesApiUpdateCommunityVideoCommunitiesCommunityIdVideoPut
     */
    readonly communityId: string

    /**
     * 
     * @type {File}
     * @memberof CommunitiesApiUpdateCommunityVideoCommunitiesCommunityIdVideoPut
     */
    readonly file: File
}

/**
 * CommunitiesApi - object-oriented interface
 * @export
 * @class CommunitiesApi
 * @extends {BaseAPI}
 */
export class CommunitiesApi extends BaseAPI {
    /**
     * Get multiple communities by their IDs
     * @summary Bulk Get Communities
     * @param {CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public bulkGetCommunitiesCommunitiesBulkPost(requestParameters: CommunitiesApiBulkGetCommunitiesCommunitiesBulkPostRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).bulkGetCommunitiesCommunitiesBulkPost(requestParameters.bulkGetCommunitiesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new community
     * @summary Create Community
     * @param {CommunitiesApiCreateCommunityCommunitiesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public createCommunityCommunitiesPost(requestParameters: CommunitiesApiCreateCommunityCommunitiesPostRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).createCommunityCommunitiesPost(requestParameters.createCommunityInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create community metadata (community owner only)
     * @summary Create Community Meta
     * @param {CommunitiesApiCreateCommunityMetaCommunitiesCommunityIdMetaPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public createCommunityMetaCommunitiesCommunityIdMetaPost(requestParameters: CommunitiesApiCreateCommunityMetaCommunitiesCommunityIdMetaPostRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).createCommunityMetaCommunitiesCommunityIdMetaPost(requestParameters.communityId, requestParameters.createCommunityMetaInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a community (soft delete)
     * @summary Delete Community
     * @param {CommunitiesApiDeleteCommunityCommunitiesCommunityIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public deleteCommunityCommunitiesCommunityIdDelete(requestParameters: CommunitiesApiDeleteCommunityCommunitiesCommunityIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).deleteCommunityCommunitiesCommunityIdDelete(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete community metadata (admin only)
     * @summary Delete Community Meta
     * @param {CommunitiesApiDeleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete(requestParameters: CommunitiesApiDeleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).deleteCommunityMetaCommunitiesCommunityIdMetaMetaIdDelete(requestParameters.communityId, requestParameters.metaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all communities with pagination
     * @summary Get Communities
     * @param {CommunitiesApiGetCommunitiesCommunitiesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public getCommunitiesCommunitiesGet(requestParameters: CommunitiesApiGetCommunitiesCommunitiesGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).getCommunitiesCommunitiesGet(requestParameters.communityType, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a community by slug
     * @summary Get Community By Slug
     * @param {CommunitiesApiGetCommunityBySlugCommunitiesSlugSlugGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public getCommunityBySlugCommunitiesSlugSlugGet(requestParameters: CommunitiesApiGetCommunityBySlugCommunitiesSlugSlugGetRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).getCommunityBySlugCommunitiesSlugSlugGet(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a community by ID
     * @summary Get Community
     * @param {CommunitiesApiGetCommunityCommunitiesCommunityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public getCommunityCommunitiesCommunityIdGet(requestParameters: CommunitiesApiGetCommunityCommunitiesCommunityIdGetRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).getCommunityCommunitiesCommunityIdGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get community metadata (admin only)
     * @summary Get Community Meta
     * @param {CommunitiesApiGetCommunityMetaCommunitiesCommunityIdMetaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public getCommunityMetaCommunitiesCommunityIdMetaGet(requestParameters: CommunitiesApiGetCommunityMetaCommunitiesCommunityIdMetaGetRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).getCommunityMetaCommunitiesCommunityIdMetaGet(requestParameters.communityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all community metadata (admin only)
     * @summary List Community Metas
     * @param {CommunitiesApiListCommunityMetasCommunitiesMetaGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public listCommunityMetasCommunitiesMetaGet(requestParameters: CommunitiesApiListCommunityMetasCommunitiesMetaGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).listCommunityMetasCommunitiesMetaGet(requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search communities by name, headline, or bio
     * @summary Search Communities
     * @param {CommunitiesApiSearchCommunitiesCommunitiesSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public searchCommunitiesCommunitiesSearchGet(requestParameters: CommunitiesApiSearchCommunitiesCommunitiesSearchGetRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).searchCommunitiesCommunitiesSearchGet(requestParameters.query, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a community
     * @summary Update Community
     * @param {CommunitiesApiUpdateCommunityCommunitiesCommunityIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public updateCommunityCommunitiesCommunityIdPut(requestParameters: CommunitiesApiUpdateCommunityCommunitiesCommunityIdPutRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).updateCommunityCommunitiesCommunityIdPut(requestParameters.communityId, requestParameters.updateCommunityInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update community social links
     * @summary Update Community Links
     * @param {CommunitiesApiUpdateCommunityLinksCommunitiesCommunityIdLinksPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public updateCommunityLinksCommunitiesCommunityIdLinksPut(requestParameters: CommunitiesApiUpdateCommunityLinksCommunitiesCommunityIdLinksPutRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).updateCommunityLinksCommunitiesCommunityIdLinksPut(requestParameters.communityId, requestParameters.updateCommunityLinksInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update community photo
     * @summary Update Community Photo
     * @param {CommunitiesApiUpdateCommunityPhotoCommunitiesCommunityIdPhotoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public updateCommunityPhotoCommunitiesCommunityIdPhotoPut(requestParameters: CommunitiesApiUpdateCommunityPhotoCommunitiesCommunityIdPhotoPutRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).updateCommunityPhotoCommunitiesCommunityIdPhotoPut(requestParameters.communityId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update community video
     * @summary Update Community Video
     * @param {CommunitiesApiUpdateCommunityVideoCommunitiesCommunityIdVideoPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunitiesApi
     */
    public updateCommunityVideoCommunitiesCommunityIdVideoPut(requestParameters: CommunitiesApiUpdateCommunityVideoCommunitiesCommunityIdVideoPutRequest, options?: RawAxiosRequestConfig) {
        return CommunitiesApiFp(this.configuration).updateCommunityVideoCommunitiesCommunityIdVideoPut(requestParameters.communityId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProfilesApi - axios parameter creator
 * @export
 */
export const ProfilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add work experience to a person
         * @summary Add Person Experience
         * @param {string} personId 
         * @param {AddPersonExperienceInput} addPersonExperienceInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPersonExperienceProfilesPeoplePersonIdExperiencesPost: async (personId: string, addPersonExperienceInput: AddPersonExperienceInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('addPersonExperienceProfilesPeoplePersonIdExperiencesPost', 'personId', personId)
            // verify required parameter 'addPersonExperienceInput' is not null or undefined
            assertParamExists('addPersonExperienceProfilesPeoplePersonIdExperiencesPost', 'addPersonExperienceInput', addPersonExperienceInput)
            const localVarPath = `/profiles/people/{person_id}/experiences/`
                .replace(`{${"person_id"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPersonExperienceInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a canonical tag to a user profile
         * @summary Assign Profile Tag
         * @param {string} communityId 
         * @param {AssignProfileTagInput} assignProfileTagInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost: async (communityId: string, assignProfileTagInput: AssignProfileTagInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost', 'communityId', communityId)
            // verify required parameter 'assignProfileTagInput' is not null or undefined
            assertParamExists('assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost', 'assignProfileTagInput', assignProfileTagInput)
            const localVarPath = `/profiles/communities/{community_id}/tags/assign/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignProfileTagInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Block User
         * @param {string} userId 
         * @param {BlockedUserInput} blockedUserInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUserProfilesUsersUserIdBlocksPost: async (userId: string, blockedUserInput: BlockedUserInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('blockUserProfilesUsersUserIdBlocksPost', 'userId', userId)
            // verify required parameter 'blockedUserInput' is not null or undefined
            assertParamExists('blockUserProfilesUsersUserIdBlocksPost', 'blockedUserInput', blockedUserInput)
            const localVarPath = `/profiles/users/{user_id}/blocks/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockedUserInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Create Profiles
         * @param {BulkCreateProfilesInput} bulkCreateProfilesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateProfilesProfilesUsersBulkCreatePost: async (bulkCreateProfilesInput: BulkCreateProfilesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkCreateProfilesInput' is not null or undefined
            assertParamExists('bulkCreateProfilesProfilesUsersBulkCreatePost', 'bulkCreateProfilesInput', bulkCreateProfilesInput)
            const localVarPath = `/profiles/users/bulk_create/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkCreateProfilesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk Get Profile
         * @param {BulkGetProfilesInput} bulkGetProfilesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetProfileProfilesUsersBulkPost: async (bulkGetProfilesInput: BulkGetProfilesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkGetProfilesInput' is not null or undefined
            assertParamExists('bulkGetProfileProfilesUsersBulkPost', 'bulkGetProfilesInput', bulkGetProfilesInput)
            const localVarPath = `/profiles/users/bulk/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkGetProfilesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check If Blocked
         * @param {string} userId 
         * @param {string} blockedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet: async (userId: string, blockedUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet', 'userId', userId)
            // verify required parameter 'blockedUserId' is not null or undefined
            assertParamExists('checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet', 'blockedUserId', blockedUserId)
            const localVarPath = `/profiles/users/{user_id}/blocks/{blocked_user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"blocked_user_id"}}`, encodeURIComponent(String(blockedUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a canonical profile tag definition for a community
         * @summary Create Canonical Tag
         * @param {string} communityId 
         * @param {CreateCanonicalProfileTagInput} createCanonicalProfileTagInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCanonicalTagProfilesCommunitiesCommunityIdTagsPost: async (communityId: string, createCanonicalProfileTagInput: CreateCanonicalProfileTagInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('createCanonicalTagProfilesCommunitiesCommunityIdTagsPost', 'communityId', communityId)
            // verify required parameter 'createCanonicalProfileTagInput' is not null or undefined
            assertParamExists('createCanonicalTagProfilesCommunitiesCommunityIdTagsPost', 'createCanonicalProfileTagInput', createCanonicalProfileTagInput)
            const localVarPath = `/profiles/communities/{community_id}/tags/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCanonicalProfileTagInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new person enrichment record
         * @summary Create Person
         * @param {CreatePersonInput} createPersonInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonProfilesPeoplePost: async (createPersonInput: CreatePersonInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPersonInput' is not null or undefined
            assertParamExists('createPersonProfilesPeoplePost', 'createPersonInput', createPersonInput)
            const localVarPath = `/profiles/people/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPersonInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Profile
         * @param {CreateProfileInput} createProfileInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfileProfilesPost: async (createProfileInput: CreateProfileInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProfileInput' is not null or undefined
            assertParamExists('createProfileProfilesPost', 'createProfileInput', createProfileInput)
            const localVarPath = `/profiles/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProfileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete a canonical profile tag
         * @summary Delete Canonical Tag
         * @param {string} communityId 
         * @param {string} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete: async (communityId: string, tagId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete', 'communityId', communityId)
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete', 'tagId', tagId)
            const localVarPath = `/profiles/communities/{community_id}/tags/{tag_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft-delete a person\'s work experience
         * @summary Delete Person Experience
         * @param {string} personId 
         * @param {string} experienceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete: async (personId: string, experienceId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete', 'personId', personId)
            // verify required parameter 'experienceId' is not null or undefined
            assertParamExists('deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete', 'experienceId', experienceId)
            const localVarPath = `/profiles/people/{person_id}/experiences/{experience_id}/`
                .replace(`{${"person_id"}}`, encodeURIComponent(String(personId)))
                .replace(`{${"experience_id"}}`, encodeURIComponent(String(experienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Blocked Users
         * @param {string} userId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedUsersProfilesUsersUserIdBlocksGet: async (userId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getBlockedUsersProfilesUsersUserIdBlocksGet', 'userId', userId)
            const localVarPath = `/profiles/users/{user_id}/blocks/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all canonical tags for a community
         * @summary Get Canonical Tags
         * @param {string} communityId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanonicalTagsProfilesCommunitiesCommunityIdTagsGet: async (communityId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getCanonicalTagsProfilesCommunitiesCommunityIdTagsGet', 'communityId', communityId)
            const localVarPath = `/profiles/communities/{community_id}/tags/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get person enrichment data by profile user_id
         * @summary Get Person By Profile
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonByProfileProfilesProfilesUserIdPersonGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPersonByProfileProfilesProfilesUserIdPersonGet', 'userId', userId)
            const localVarPath = `/profiles/profiles/{user_id}/person/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all work experiences for a person
         * @summary Get Person Experiences
         * @param {string} personId 
         * @param {boolean} [currentOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonExperiencesProfilesPeoplePersonIdExperiencesGet: async (personId: string, currentOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('getPersonExperiencesProfilesPeoplePersonIdExperiencesGet', 'personId', personId)
            const localVarPath = `/profiles/people/{person_id}/experiences/`
                .replace(`{${"person_id"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (currentOnly !== undefined) {
                localVarQueryParameter['current_only'] = currentOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get person enrichment data by person ID
         * @summary Get Person
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonProfilesPeoplePersonIdGet: async (personId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('getPersonProfilesPeoplePersonIdGet', 'personId', personId)
            const localVarPath = `/profiles/people/{person_id}/`
                .replace(`{${"person_id"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Profile
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileProfilesUsersUserIdGet: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProfileProfilesUsersUserIdGet', 'userId', userId)
            const localVarPath = `/profiles/users/{user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all profile tags assigned to a user by a specific community
         * @summary Get Profile Tags
         * @param {string} communityId 
         * @param {string} userId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet: async (communityId: string, userId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet', 'communityId', communityId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet', 'userId', userId)
            const localVarPath = `/profiles/communities/{community_id}/users/{user_id}/tags/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for profiles by first and last name. Supports partial matches and pagination.
         * @summary Search Profiles
         * @param {SearchProfilesInput} searchProfilesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProfilesProfilesSearchPost: async (searchProfilesInput: SearchProfilesInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchProfilesInput' is not null or undefined
            assertParamExists('searchProfilesProfilesSearchPost', 'searchProfilesInput', searchProfilesInput)
            const localVarPath = `/profiles/search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchProfilesInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unassign a tag from a user profile
         * @summary Unassign Profile Tag
         * @param {string} communityId 
         * @param {string} profileTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete: async (communityId: string, profileTagId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete', 'communityId', communityId)
            // verify required parameter 'profileTagId' is not null or undefined
            assertParamExists('unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete', 'profileTagId', profileTagId)
            const localVarPath = `/profiles/communities/{community_id}/tags/assign/{profile_tag_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"profile_tag_id"}}`, encodeURIComponent(String(profileTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unblock User
         * @param {string} userId 
         * @param {string} blockedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete: async (userId: string, blockedUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete', 'userId', userId)
            // verify required parameter 'blockedUserId' is not null or undefined
            assertParamExists('unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete', 'blockedUserId', blockedUserId)
            const localVarPath = `/profiles/users/{user_id}/blocks/{blocked_user_id}/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"blocked_user_id"}}`, encodeURIComponent(String(blockedUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a canonical profile tag
         * @summary Update Canonical Tag
         * @param {string} communityId 
         * @param {string} tagId 
         * @param {UpdateCanonicalProfileTagInput} updateCanonicalProfileTagInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut: async (communityId: string, tagId: string, updateCanonicalProfileTagInput: UpdateCanonicalProfileTagInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'communityId' is not null or undefined
            assertParamExists('updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut', 'communityId', communityId)
            // verify required parameter 'tagId' is not null or undefined
            assertParamExists('updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut', 'tagId', tagId)
            // verify required parameter 'updateCanonicalProfileTagInput' is not null or undefined
            assertParamExists('updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut', 'updateCanonicalProfileTagInput', updateCanonicalProfileTagInput)
            const localVarPath = `/profiles/communities/{community_id}/tags/{tag_id}/`
                .replace(`{${"community_id"}}`, encodeURIComponent(String(communityId)))
                .replace(`{${"tag_id"}}`, encodeURIComponent(String(tagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCanonicalProfileTagInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a person\'s work experience
         * @summary Update Person Experience
         * @param {string} personId 
         * @param {string} experienceId 
         * @param {UpdatePersonExperienceInput} updatePersonExperienceInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut: async (personId: string, experienceId: string, updatePersonExperienceInput: UpdatePersonExperienceInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut', 'personId', personId)
            // verify required parameter 'experienceId' is not null or undefined
            assertParamExists('updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut', 'experienceId', experienceId)
            // verify required parameter 'updatePersonExperienceInput' is not null or undefined
            assertParamExists('updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut', 'updatePersonExperienceInput', updatePersonExperienceInput)
            const localVarPath = `/profiles/people/{person_id}/experiences/{experience_id}/`
                .replace(`{${"person_id"}}`, encodeURIComponent(String(personId)))
                .replace(`{${"experience_id"}}`, encodeURIComponent(String(experienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePersonExperienceInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update person enrichment data
         * @summary Update Person
         * @param {string} personId 
         * @param {UpdatePersonInput} updatePersonInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonProfilesPeoplePersonIdPut: async (personId: string, updatePersonInput: UpdatePersonInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('updatePersonProfilesPeoplePersonIdPut', 'personId', personId)
            // verify required parameter 'updatePersonInput' is not null or undefined
            assertParamExists('updatePersonProfilesPeoplePersonIdPut', 'updatePersonInput', updatePersonInput)
            const localVarPath = `/profiles/people/{person_id}/`
                .replace(`{${"person_id"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePersonInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Photo
         * @param {string} userId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhotoProfilesUsersUserIdPhotosPut: async (userId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updatePhotoProfilesUsersUserIdPhotosPut', 'userId', userId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('updatePhotoProfilesUsersUserIdPhotosPut', 'file', file)
            const localVarPath = `/profiles/users/{user_id}/photos/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Profile Links
         * @param {string} userId 
         * @param {UpdateProfileLinksInput} updateProfileLinksInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileLinksProfilesUsersUserIdLinksPut: async (userId: string, updateProfileLinksInput: UpdateProfileLinksInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProfileLinksProfilesUsersUserIdLinksPut', 'userId', userId)
            // verify required parameter 'updateProfileLinksInput' is not null or undefined
            assertParamExists('updateProfileLinksProfilesUsersUserIdLinksPut', 'updateProfileLinksInput', updateProfileLinksInput)
            const localVarPath = `/profiles/users/{user_id}/links/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileLinksInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Profile
         * @param {UpdateProfileInput} updateProfileInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileProfilesPut: async (updateProfileInput: UpdateProfileInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProfileInput' is not null or undefined
            assertParamExists('updateProfileProfilesPut', 'updateProfileInput', updateProfileInput)
            const localVarPath = `/profiles/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Video
         * @param {string} userId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVideoProfilesUsersUserIdVideosPut: async (userId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateVideoProfilesUsersUserIdVideosPut', 'userId', userId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('updateVideoProfilesUsersUserIdVideosPut', 'file', file)
            const localVarPath = `/profiles/users/{user_id}/videos/`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication HTTPBearerWith401 required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfilesApi - functional programming interface
 * @export
 */
export const ProfilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfilesApiAxiosParamCreator(configuration)
    return {
        /**
         * Add work experience to a person
         * @summary Add Person Experience
         * @param {string} personId 
         * @param {AddPersonExperienceInput} addPersonExperienceInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPersonExperienceProfilesPeoplePersonIdExperiencesPost(personId: string, addPersonExperienceInput: AddPersonExperienceInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonExperienceOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPersonExperienceProfilesPeoplePersonIdExperiencesPost(personId, addPersonExperienceInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.addPersonExperienceProfilesPeoplePersonIdExperiencesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Assign a canonical tag to a user profile
         * @summary Assign Profile Tag
         * @param {string} communityId 
         * @param {AssignProfileTagInput} assignProfileTagInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost(communityId: string, assignProfileTagInput: AssignProfileTagInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileTagOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost(communityId, assignProfileTagInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Block User
         * @param {string} userId 
         * @param {BlockedUserInput} blockedUserInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockUserProfilesUsersUserIdBlocksPost(userId: string, blockedUserInput: BlockedUserInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockedUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockUserProfilesUsersUserIdBlocksPost(userId, blockedUserInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.blockUserProfilesUsersUserIdBlocksPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Create Profiles
         * @param {BulkCreateProfilesInput} bulkCreateProfilesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkCreateProfilesProfilesUsersBulkCreatePost(bulkCreateProfilesInput: BulkCreateProfilesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Profile>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkCreateProfilesProfilesUsersBulkCreatePost(bulkCreateProfilesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.bulkCreateProfilesProfilesUsersBulkCreatePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk Get Profile
         * @param {BulkGetProfilesInput} bulkGetProfilesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetProfileProfilesUsersBulkPost(bulkGetProfilesInput: BulkGetProfilesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Profile>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetProfileProfilesUsersBulkPost(bulkGetProfilesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.bulkGetProfileProfilesUsersBulkPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Check If Blocked
         * @param {string} userId 
         * @param {string} blockedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet(userId: string, blockedUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IsBlockedOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet(userId, blockedUserId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a canonical profile tag definition for a community
         * @summary Create Canonical Tag
         * @param {string} communityId 
         * @param {CreateCanonicalProfileTagInput} createCanonicalProfileTagInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCanonicalTagProfilesCommunitiesCommunityIdTagsPost(communityId: string, createCanonicalProfileTagInput: CreateCanonicalProfileTagInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanonicalProfileTagOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCanonicalTagProfilesCommunitiesCommunityIdTagsPost(communityId, createCanonicalProfileTagInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.createCanonicalTagProfilesCommunitiesCommunityIdTagsPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Create a new person enrichment record
         * @summary Create Person
         * @param {CreatePersonInput} createPersonInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPersonProfilesPeoplePost(createPersonInput: CreatePersonInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPersonProfilesPeoplePost(createPersonInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.createPersonProfilesPeoplePost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create Profile
         * @param {CreateProfileInput} createProfileInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProfileProfilesPost(createProfileInput: CreateProfileInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProfileProfilesPost(createProfileInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.createProfileProfilesPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Soft-delete a canonical profile tag
         * @summary Delete Canonical Tag
         * @param {string} communityId 
         * @param {string} tagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete(communityId: string, tagId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete(communityId, tagId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Soft-delete a person\'s work experience
         * @summary Delete Person Experience
         * @param {string} personId 
         * @param {string} experienceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete(personId: string, experienceId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete(personId, experienceId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Blocked Users
         * @param {string} userId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBlockedUsersProfilesUsersUserIdBlocksGet(userId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockedUsersPaginatorBlockedUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBlockedUsersProfilesUsersUserIdBlocksGet(userId, limit, offset, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.getBlockedUsersProfilesUsersUserIdBlocksGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all canonical tags for a community
         * @summary Get Canonical Tags
         * @param {string} communityId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCanonicalTagsProfilesCommunitiesCommunityIdTagsGet(communityId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CanonicalProfileTagOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCanonicalTagsProfilesCommunitiesCommunityIdTagsGet(communityId, limit, offset, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.getCanonicalTagsProfilesCommunitiesCommunityIdTagsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get person enrichment data by profile user_id
         * @summary Get Person By Profile
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonByProfileProfilesProfilesUserIdPersonGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonByProfileProfilesProfilesUserIdPersonGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.getPersonByProfileProfilesProfilesUserIdPersonGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all work experiences for a person
         * @summary Get Person Experiences
         * @param {string} personId 
         * @param {boolean} [currentOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonExperiencesProfilesPeoplePersonIdExperiencesGet(personId: string, currentOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PersonExperienceOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonExperiencesProfilesPeoplePersonIdExperiencesGet(personId, currentOnly, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.getPersonExperiencesProfilesPeoplePersonIdExperiencesGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get person enrichment data by person ID
         * @summary Get Person
         * @param {string} personId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonProfilesPeoplePersonIdGet(personId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonProfilesPeoplePersonIdGet(personId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.getPersonProfilesPeoplePersonIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Profile
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileProfilesUsersUserIdGet(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileProfilesUsersUserIdGet(userId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.getProfileProfilesUsersUserIdGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get all profile tags assigned to a user by a specific community
         * @summary Get Profile Tags
         * @param {string} communityId 
         * @param {string} userId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet(communityId: string, userId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProfileTagOutput>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet(communityId, userId, limit, offset, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Search for profiles by first and last name. Supports partial matches and pagination.
         * @summary Search Profiles
         * @param {SearchProfilesInput} searchProfilesInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProfilesProfilesSearchPost(searchProfilesInput: SearchProfilesInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileSearchPaginatorProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProfilesProfilesSearchPost(searchProfilesInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.searchProfilesProfilesSearchPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Unassign a tag from a user profile
         * @summary Unassign Profile Tag
         * @param {string} communityId 
         * @param {string} profileTagId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete(communityId: string, profileTagId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete(communityId, profileTagId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Unblock User
         * @param {string} userId 
         * @param {string} blockedUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete(userId: string, blockedUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete(userId, blockedUserId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a canonical profile tag
         * @summary Update Canonical Tag
         * @param {string} communityId 
         * @param {string} tagId 
         * @param {UpdateCanonicalProfileTagInput} updateCanonicalProfileTagInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut(communityId: string, tagId: string, updateCanonicalProfileTagInput: UpdateCanonicalProfileTagInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CanonicalProfileTagOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut(communityId, tagId, updateCanonicalProfileTagInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update a person\'s work experience
         * @summary Update Person Experience
         * @param {string} personId 
         * @param {string} experienceId 
         * @param {UpdatePersonExperienceInput} updatePersonExperienceInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut(personId: string, experienceId: string, updatePersonExperienceInput: UpdatePersonExperienceInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonExperienceOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut(personId, experienceId, updatePersonExperienceInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Update person enrichment data
         * @summary Update Person
         * @param {string} personId 
         * @param {UpdatePersonInput} updatePersonInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePersonProfilesPeoplePersonIdPut(personId: string, updatePersonInput: UpdatePersonInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePersonProfilesPeoplePersonIdPut(personId, updatePersonInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.updatePersonProfilesPeoplePersonIdPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update Photo
         * @param {string} userId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePhotoProfilesUsersUserIdPhotosPut(userId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePhotoProfilesUsersUserIdPhotosPut(userId, file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.updatePhotoProfilesUsersUserIdPhotosPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update Profile Links
         * @param {string} userId 
         * @param {UpdateProfileLinksInput} updateProfileLinksInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfileLinksProfilesUsersUserIdLinksPut(userId: string, updateProfileLinksInput: UpdateProfileLinksInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfileLinksProfilesUsersUserIdLinksPut(userId, updateProfileLinksInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.updateProfileLinksProfilesUsersUserIdLinksPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update Profile
         * @param {UpdateProfileInput} updateProfileInput 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfileProfilesPut(updateProfileInput: UpdateProfileInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfileProfilesPut(updateProfileInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.updateProfileProfilesPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update Video
         * @param {string} userId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVideoProfilesUsersUserIdVideosPut(userId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVideoProfilesUsersUserIdVideosPut(userId, file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ProfilesApi.updateVideoProfilesUsersUserIdVideosPut']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ProfilesApi - factory interface
 * @export
 */
export const ProfilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfilesApiFp(configuration)
    return {
        /**
         * Add work experience to a person
         * @summary Add Person Experience
         * @param {ProfilesApiAddPersonExperienceProfilesPeoplePersonIdExperiencesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPersonExperienceProfilesPeoplePersonIdExperiencesPost(requestParameters: ProfilesApiAddPersonExperienceProfilesPeoplePersonIdExperiencesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PersonExperienceOutput> {
            return localVarFp.addPersonExperienceProfilesPeoplePersonIdExperiencesPost(requestParameters.personId, requestParameters.addPersonExperienceInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a canonical tag to a user profile
         * @summary Assign Profile Tag
         * @param {ProfilesApiAssignProfileTagProfilesCommunitiesCommunityIdTagsAssignPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost(requestParameters: ProfilesApiAssignProfileTagProfilesCommunitiesCommunityIdTagsAssignPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileTagOutput> {
            return localVarFp.assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost(requestParameters.communityId, requestParameters.assignProfileTagInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Block User
         * @param {ProfilesApiBlockUserProfilesUsersUserIdBlocksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUserProfilesUsersUserIdBlocksPost(requestParameters: ProfilesApiBlockUserProfilesUsersUserIdBlocksPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<BlockedUser> {
            return localVarFp.blockUserProfilesUsersUserIdBlocksPost(requestParameters.userId, requestParameters.blockedUserInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Create Profiles
         * @param {ProfilesApiBulkCreateProfilesProfilesUsersBulkCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkCreateProfilesProfilesUsersBulkCreatePost(requestParameters: ProfilesApiBulkCreateProfilesProfilesUsersBulkCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Profile>> {
            return localVarFp.bulkCreateProfilesProfilesUsersBulkCreatePost(requestParameters.bulkCreateProfilesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk Get Profile
         * @param {ProfilesApiBulkGetProfileProfilesUsersBulkPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetProfileProfilesUsersBulkPost(requestParameters: ProfilesApiBulkGetProfileProfilesUsersBulkPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<Profile>> {
            return localVarFp.bulkGetProfileProfilesUsersBulkPost(requestParameters.bulkGetProfilesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check If Blocked
         * @param {ProfilesApiCheckIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet(requestParameters: ProfilesApiCheckIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<IsBlockedOutput> {
            return localVarFp.checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet(requestParameters.userId, requestParameters.blockedUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a canonical profile tag definition for a community
         * @summary Create Canonical Tag
         * @param {ProfilesApiCreateCanonicalTagProfilesCommunitiesCommunityIdTagsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCanonicalTagProfilesCommunitiesCommunityIdTagsPost(requestParameters: ProfilesApiCreateCanonicalTagProfilesCommunitiesCommunityIdTagsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<CanonicalProfileTagOutput> {
            return localVarFp.createCanonicalTagProfilesCommunitiesCommunityIdTagsPost(requestParameters.communityId, requestParameters.createCanonicalProfileTagInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new person enrichment record
         * @summary Create Person
         * @param {ProfilesApiCreatePersonProfilesPeoplePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPersonProfilesPeoplePost(requestParameters: ProfilesApiCreatePersonProfilesPeoplePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PersonOutput> {
            return localVarFp.createPersonProfilesPeoplePost(requestParameters.createPersonInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Profile
         * @param {ProfilesApiCreateProfileProfilesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProfileProfilesPost(requestParameters: ProfilesApiCreateProfileProfilesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Profile> {
            return localVarFp.createProfileProfilesPost(requestParameters.createProfileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete a canonical profile tag
         * @summary Delete Canonical Tag
         * @param {ProfilesApiDeleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete(requestParameters: ProfilesApiDeleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete(requestParameters.communityId, requestParameters.tagId, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft-delete a person\'s work experience
         * @summary Delete Person Experience
         * @param {ProfilesApiDeletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete(requestParameters: ProfilesApiDeletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete(requestParameters.personId, requestParameters.experienceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Blocked Users
         * @param {ProfilesApiGetBlockedUsersProfilesUsersUserIdBlocksGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBlockedUsersProfilesUsersUserIdBlocksGet(requestParameters: ProfilesApiGetBlockedUsersProfilesUsersUserIdBlocksGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<BlockedUsersPaginatorBlockedUser> {
            return localVarFp.getBlockedUsersProfilesUsersUserIdBlocksGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all canonical tags for a community
         * @summary Get Canonical Tags
         * @param {ProfilesApiGetCanonicalTagsProfilesCommunitiesCommunityIdTagsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCanonicalTagsProfilesCommunitiesCommunityIdTagsGet(requestParameters: ProfilesApiGetCanonicalTagsProfilesCommunitiesCommunityIdTagsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CanonicalProfileTagOutput>> {
            return localVarFp.getCanonicalTagsProfilesCommunitiesCommunityIdTagsGet(requestParameters.communityId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get person enrichment data by profile user_id
         * @summary Get Person By Profile
         * @param {ProfilesApiGetPersonByProfileProfilesProfilesUserIdPersonGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonByProfileProfilesProfilesUserIdPersonGet(requestParameters: ProfilesApiGetPersonByProfileProfilesProfilesUserIdPersonGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PersonOutput> {
            return localVarFp.getPersonByProfileProfilesProfilesUserIdPersonGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all work experiences for a person
         * @summary Get Person Experiences
         * @param {ProfilesApiGetPersonExperiencesProfilesPeoplePersonIdExperiencesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonExperiencesProfilesPeoplePersonIdExperiencesGet(requestParameters: ProfilesApiGetPersonExperiencesProfilesPeoplePersonIdExperiencesGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PersonExperienceOutput>> {
            return localVarFp.getPersonExperiencesProfilesPeoplePersonIdExperiencesGet(requestParameters.personId, requestParameters.currentOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Get person enrichment data by person ID
         * @summary Get Person
         * @param {ProfilesApiGetPersonProfilesPeoplePersonIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonProfilesPeoplePersonIdGet(requestParameters: ProfilesApiGetPersonProfilesPeoplePersonIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PersonOutput> {
            return localVarFp.getPersonProfilesPeoplePersonIdGet(requestParameters.personId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Profile
         * @param {ProfilesApiGetProfileProfilesUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileProfilesUsersUserIdGet(requestParameters: ProfilesApiGetProfileProfilesUsersUserIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Profile> {
            return localVarFp.getProfileProfilesUsersUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all profile tags assigned to a user by a specific community
         * @summary Get Profile Tags
         * @param {ProfilesApiGetProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet(requestParameters: ProfilesApiGetProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ProfileTagOutput>> {
            return localVarFp.getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet(requestParameters.communityId, requestParameters.userId, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for profiles by first and last name. Supports partial matches and pagination.
         * @summary Search Profiles
         * @param {ProfilesApiSearchProfilesProfilesSearchPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProfilesProfilesSearchPost(requestParameters: ProfilesApiSearchProfilesProfilesSearchPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileSearchPaginatorProfile> {
            return localVarFp.searchProfilesProfilesSearchPost(requestParameters.searchProfilesInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Unassign a tag from a user profile
         * @summary Unassign Profile Tag
         * @param {ProfilesApiUnassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete(requestParameters: ProfilesApiUnassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete(requestParameters.communityId, requestParameters.profileTagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unblock User
         * @param {ProfilesApiUnblockUserProfilesUsersUserIdBlocksBlockedUserIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete(requestParameters: ProfilesApiUnblockUserProfilesUsersUserIdBlocksBlockedUserIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete(requestParameters.userId, requestParameters.blockedUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a canonical profile tag
         * @summary Update Canonical Tag
         * @param {ProfilesApiUpdateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut(requestParameters: ProfilesApiUpdateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<CanonicalProfileTagOutput> {
            return localVarFp.updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut(requestParameters.communityId, requestParameters.tagId, requestParameters.updateCanonicalProfileTagInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a person\'s work experience
         * @summary Update Person Experience
         * @param {ProfilesApiUpdatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut(requestParameters: ProfilesApiUpdatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PersonExperienceOutput> {
            return localVarFp.updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut(requestParameters.personId, requestParameters.experienceId, requestParameters.updatePersonExperienceInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Update person enrichment data
         * @summary Update Person
         * @param {ProfilesApiUpdatePersonProfilesPeoplePersonIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePersonProfilesPeoplePersonIdPut(requestParameters: ProfilesApiUpdatePersonProfilesPeoplePersonIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<PersonOutput> {
            return localVarFp.updatePersonProfilesPeoplePersonIdPut(requestParameters.personId, requestParameters.updatePersonInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Photo
         * @param {ProfilesApiUpdatePhotoProfilesUsersUserIdPhotosPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhotoProfilesUsersUserIdPhotosPut(requestParameters: ProfilesApiUpdatePhotoProfilesUsersUserIdPhotosPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updatePhotoProfilesUsersUserIdPhotosPut(requestParameters.userId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Profile Links
         * @param {ProfilesApiUpdateProfileLinksProfilesUsersUserIdLinksPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileLinksProfilesUsersUserIdLinksPut(requestParameters: ProfilesApiUpdateProfileLinksProfilesUsersUserIdLinksPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateProfileLinksProfilesUsersUserIdLinksPut(requestParameters.userId, requestParameters.updateProfileLinksInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Profile
         * @param {ProfilesApiUpdateProfileProfilesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileProfilesPut(requestParameters: ProfilesApiUpdateProfileProfilesPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateProfileProfilesPut(requestParameters.updateProfileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Video
         * @param {ProfilesApiUpdateVideoProfilesUsersUserIdVideosPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVideoProfilesUsersUserIdVideosPut(requestParameters: ProfilesApiUpdateVideoProfilesUsersUserIdVideosPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.updateVideoProfilesUsersUserIdVideosPut(requestParameters.userId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addPersonExperienceProfilesPeoplePersonIdExperiencesPost operation in ProfilesApi.
 * @export
 * @interface ProfilesApiAddPersonExperienceProfilesPeoplePersonIdExperiencesPostRequest
 */
export interface ProfilesApiAddPersonExperienceProfilesPeoplePersonIdExperiencesPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiAddPersonExperienceProfilesPeoplePersonIdExperiencesPost
     */
    readonly personId: string

    /**
     * 
     * @type {AddPersonExperienceInput}
     * @memberof ProfilesApiAddPersonExperienceProfilesPeoplePersonIdExperiencesPost
     */
    readonly addPersonExperienceInput: AddPersonExperienceInput
}

/**
 * Request parameters for assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost operation in ProfilesApi.
 * @export
 * @interface ProfilesApiAssignProfileTagProfilesCommunitiesCommunityIdTagsAssignPostRequest
 */
export interface ProfilesApiAssignProfileTagProfilesCommunitiesCommunityIdTagsAssignPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiAssignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost
     */
    readonly communityId: string

    /**
     * 
     * @type {AssignProfileTagInput}
     * @memberof ProfilesApiAssignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost
     */
    readonly assignProfileTagInput: AssignProfileTagInput
}

/**
 * Request parameters for blockUserProfilesUsersUserIdBlocksPost operation in ProfilesApi.
 * @export
 * @interface ProfilesApiBlockUserProfilesUsersUserIdBlocksPostRequest
 */
export interface ProfilesApiBlockUserProfilesUsersUserIdBlocksPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiBlockUserProfilesUsersUserIdBlocksPost
     */
    readonly userId: string

    /**
     * 
     * @type {BlockedUserInput}
     * @memberof ProfilesApiBlockUserProfilesUsersUserIdBlocksPost
     */
    readonly blockedUserInput: BlockedUserInput
}

/**
 * Request parameters for bulkCreateProfilesProfilesUsersBulkCreatePost operation in ProfilesApi.
 * @export
 * @interface ProfilesApiBulkCreateProfilesProfilesUsersBulkCreatePostRequest
 */
export interface ProfilesApiBulkCreateProfilesProfilesUsersBulkCreatePostRequest {
    /**
     * 
     * @type {BulkCreateProfilesInput}
     * @memberof ProfilesApiBulkCreateProfilesProfilesUsersBulkCreatePost
     */
    readonly bulkCreateProfilesInput: BulkCreateProfilesInput
}

/**
 * Request parameters for bulkGetProfileProfilesUsersBulkPost operation in ProfilesApi.
 * @export
 * @interface ProfilesApiBulkGetProfileProfilesUsersBulkPostRequest
 */
export interface ProfilesApiBulkGetProfileProfilesUsersBulkPostRequest {
    /**
     * 
     * @type {BulkGetProfilesInput}
     * @memberof ProfilesApiBulkGetProfileProfilesUsersBulkPost
     */
    readonly bulkGetProfilesInput: BulkGetProfilesInput
}

/**
 * Request parameters for checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet operation in ProfilesApi.
 * @export
 * @interface ProfilesApiCheckIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGetRequest
 */
export interface ProfilesApiCheckIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiCheckIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof ProfilesApiCheckIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet
     */
    readonly blockedUserId: string
}

/**
 * Request parameters for createCanonicalTagProfilesCommunitiesCommunityIdTagsPost operation in ProfilesApi.
 * @export
 * @interface ProfilesApiCreateCanonicalTagProfilesCommunitiesCommunityIdTagsPostRequest
 */
export interface ProfilesApiCreateCanonicalTagProfilesCommunitiesCommunityIdTagsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiCreateCanonicalTagProfilesCommunitiesCommunityIdTagsPost
     */
    readonly communityId: string

    /**
     * 
     * @type {CreateCanonicalProfileTagInput}
     * @memberof ProfilesApiCreateCanonicalTagProfilesCommunitiesCommunityIdTagsPost
     */
    readonly createCanonicalProfileTagInput: CreateCanonicalProfileTagInput
}

/**
 * Request parameters for createPersonProfilesPeoplePost operation in ProfilesApi.
 * @export
 * @interface ProfilesApiCreatePersonProfilesPeoplePostRequest
 */
export interface ProfilesApiCreatePersonProfilesPeoplePostRequest {
    /**
     * 
     * @type {CreatePersonInput}
     * @memberof ProfilesApiCreatePersonProfilesPeoplePost
     */
    readonly createPersonInput: CreatePersonInput
}

/**
 * Request parameters for createProfileProfilesPost operation in ProfilesApi.
 * @export
 * @interface ProfilesApiCreateProfileProfilesPostRequest
 */
export interface ProfilesApiCreateProfileProfilesPostRequest {
    /**
     * 
     * @type {CreateProfileInput}
     * @memberof ProfilesApiCreateProfileProfilesPost
     */
    readonly createProfileInput: CreateProfileInput
}

/**
 * Request parameters for deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete operation in ProfilesApi.
 * @export
 * @interface ProfilesApiDeleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDeleteRequest
 */
export interface ProfilesApiDeleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiDeleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof ProfilesApiDeleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete
     */
    readonly tagId: string
}

/**
 * Request parameters for deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete operation in ProfilesApi.
 * @export
 * @interface ProfilesApiDeletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDeleteRequest
 */
export interface ProfilesApiDeletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiDeletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete
     */
    readonly personId: string

    /**
     * 
     * @type {string}
     * @memberof ProfilesApiDeletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete
     */
    readonly experienceId: string
}

/**
 * Request parameters for getBlockedUsersProfilesUsersUserIdBlocksGet operation in ProfilesApi.
 * @export
 * @interface ProfilesApiGetBlockedUsersProfilesUsersUserIdBlocksGetRequest
 */
export interface ProfilesApiGetBlockedUsersProfilesUsersUserIdBlocksGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiGetBlockedUsersProfilesUsersUserIdBlocksGet
     */
    readonly userId: string

    /**
     * 
     * @type {number}
     * @memberof ProfilesApiGetBlockedUsersProfilesUsersUserIdBlocksGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof ProfilesApiGetBlockedUsersProfilesUsersUserIdBlocksGet
     */
    readonly offset?: number
}

/**
 * Request parameters for getCanonicalTagsProfilesCommunitiesCommunityIdTagsGet operation in ProfilesApi.
 * @export
 * @interface ProfilesApiGetCanonicalTagsProfilesCommunitiesCommunityIdTagsGetRequest
 */
export interface ProfilesApiGetCanonicalTagsProfilesCommunitiesCommunityIdTagsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiGetCanonicalTagsProfilesCommunitiesCommunityIdTagsGet
     */
    readonly communityId: string

    /**
     * 
     * @type {number}
     * @memberof ProfilesApiGetCanonicalTagsProfilesCommunitiesCommunityIdTagsGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof ProfilesApiGetCanonicalTagsProfilesCommunitiesCommunityIdTagsGet
     */
    readonly offset?: number
}

/**
 * Request parameters for getPersonByProfileProfilesProfilesUserIdPersonGet operation in ProfilesApi.
 * @export
 * @interface ProfilesApiGetPersonByProfileProfilesProfilesUserIdPersonGetRequest
 */
export interface ProfilesApiGetPersonByProfileProfilesProfilesUserIdPersonGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiGetPersonByProfileProfilesProfilesUserIdPersonGet
     */
    readonly userId: string
}

/**
 * Request parameters for getPersonExperiencesProfilesPeoplePersonIdExperiencesGet operation in ProfilesApi.
 * @export
 * @interface ProfilesApiGetPersonExperiencesProfilesPeoplePersonIdExperiencesGetRequest
 */
export interface ProfilesApiGetPersonExperiencesProfilesPeoplePersonIdExperiencesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiGetPersonExperiencesProfilesPeoplePersonIdExperiencesGet
     */
    readonly personId: string

    /**
     * 
     * @type {boolean}
     * @memberof ProfilesApiGetPersonExperiencesProfilesPeoplePersonIdExperiencesGet
     */
    readonly currentOnly?: boolean
}

/**
 * Request parameters for getPersonProfilesPeoplePersonIdGet operation in ProfilesApi.
 * @export
 * @interface ProfilesApiGetPersonProfilesPeoplePersonIdGetRequest
 */
export interface ProfilesApiGetPersonProfilesPeoplePersonIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiGetPersonProfilesPeoplePersonIdGet
     */
    readonly personId: string
}

/**
 * Request parameters for getProfileProfilesUsersUserIdGet operation in ProfilesApi.
 * @export
 * @interface ProfilesApiGetProfileProfilesUsersUserIdGetRequest
 */
export interface ProfilesApiGetProfileProfilesUsersUserIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiGetProfileProfilesUsersUserIdGet
     */
    readonly userId: string
}

/**
 * Request parameters for getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet operation in ProfilesApi.
 * @export
 * @interface ProfilesApiGetProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGetRequest
 */
export interface ProfilesApiGetProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiGetProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof ProfilesApiGetProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet
     */
    readonly userId: string

    /**
     * 
     * @type {number}
     * @memberof ProfilesApiGetProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof ProfilesApiGetProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet
     */
    readonly offset?: number
}

/**
 * Request parameters for searchProfilesProfilesSearchPost operation in ProfilesApi.
 * @export
 * @interface ProfilesApiSearchProfilesProfilesSearchPostRequest
 */
export interface ProfilesApiSearchProfilesProfilesSearchPostRequest {
    /**
     * 
     * @type {SearchProfilesInput}
     * @memberof ProfilesApiSearchProfilesProfilesSearchPost
     */
    readonly searchProfilesInput: SearchProfilesInput
}

/**
 * Request parameters for unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete operation in ProfilesApi.
 * @export
 * @interface ProfilesApiUnassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDeleteRequest
 */
export interface ProfilesApiUnassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUnassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUnassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete
     */
    readonly profileTagId: string
}

/**
 * Request parameters for unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete operation in ProfilesApi.
 * @export
 * @interface ProfilesApiUnblockUserProfilesUsersUserIdBlocksBlockedUserIdDeleteRequest
 */
export interface ProfilesApiUnblockUserProfilesUsersUserIdBlocksBlockedUserIdDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUnblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete
     */
    readonly userId: string

    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUnblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete
     */
    readonly blockedUserId: string
}

/**
 * Request parameters for updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut operation in ProfilesApi.
 * @export
 * @interface ProfilesApiUpdateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPutRequest
 */
export interface ProfilesApiUpdateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUpdateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut
     */
    readonly communityId: string

    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUpdateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut
     */
    readonly tagId: string

    /**
     * 
     * @type {UpdateCanonicalProfileTagInput}
     * @memberof ProfilesApiUpdateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut
     */
    readonly updateCanonicalProfileTagInput: UpdateCanonicalProfileTagInput
}

/**
 * Request parameters for updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut operation in ProfilesApi.
 * @export
 * @interface ProfilesApiUpdatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPutRequest
 */
export interface ProfilesApiUpdatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUpdatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut
     */
    readonly personId: string

    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUpdatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut
     */
    readonly experienceId: string

    /**
     * 
     * @type {UpdatePersonExperienceInput}
     * @memberof ProfilesApiUpdatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut
     */
    readonly updatePersonExperienceInput: UpdatePersonExperienceInput
}

/**
 * Request parameters for updatePersonProfilesPeoplePersonIdPut operation in ProfilesApi.
 * @export
 * @interface ProfilesApiUpdatePersonProfilesPeoplePersonIdPutRequest
 */
export interface ProfilesApiUpdatePersonProfilesPeoplePersonIdPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUpdatePersonProfilesPeoplePersonIdPut
     */
    readonly personId: string

    /**
     * 
     * @type {UpdatePersonInput}
     * @memberof ProfilesApiUpdatePersonProfilesPeoplePersonIdPut
     */
    readonly updatePersonInput: UpdatePersonInput
}

/**
 * Request parameters for updatePhotoProfilesUsersUserIdPhotosPut operation in ProfilesApi.
 * @export
 * @interface ProfilesApiUpdatePhotoProfilesUsersUserIdPhotosPutRequest
 */
export interface ProfilesApiUpdatePhotoProfilesUsersUserIdPhotosPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUpdatePhotoProfilesUsersUserIdPhotosPut
     */
    readonly userId: string

    /**
     * 
     * @type {File}
     * @memberof ProfilesApiUpdatePhotoProfilesUsersUserIdPhotosPut
     */
    readonly file: File
}

/**
 * Request parameters for updateProfileLinksProfilesUsersUserIdLinksPut operation in ProfilesApi.
 * @export
 * @interface ProfilesApiUpdateProfileLinksProfilesUsersUserIdLinksPutRequest
 */
export interface ProfilesApiUpdateProfileLinksProfilesUsersUserIdLinksPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUpdateProfileLinksProfilesUsersUserIdLinksPut
     */
    readonly userId: string

    /**
     * 
     * @type {UpdateProfileLinksInput}
     * @memberof ProfilesApiUpdateProfileLinksProfilesUsersUserIdLinksPut
     */
    readonly updateProfileLinksInput: UpdateProfileLinksInput
}

/**
 * Request parameters for updateProfileProfilesPut operation in ProfilesApi.
 * @export
 * @interface ProfilesApiUpdateProfileProfilesPutRequest
 */
export interface ProfilesApiUpdateProfileProfilesPutRequest {
    /**
     * 
     * @type {UpdateProfileInput}
     * @memberof ProfilesApiUpdateProfileProfilesPut
     */
    readonly updateProfileInput: UpdateProfileInput
}

/**
 * Request parameters for updateVideoProfilesUsersUserIdVideosPut operation in ProfilesApi.
 * @export
 * @interface ProfilesApiUpdateVideoProfilesUsersUserIdVideosPutRequest
 */
export interface ProfilesApiUpdateVideoProfilesUsersUserIdVideosPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ProfilesApiUpdateVideoProfilesUsersUserIdVideosPut
     */
    readonly userId: string

    /**
     * 
     * @type {File}
     * @memberof ProfilesApiUpdateVideoProfilesUsersUserIdVideosPut
     */
    readonly file: File
}

/**
 * ProfilesApi - object-oriented interface
 * @export
 * @class ProfilesApi
 * @extends {BaseAPI}
 */
export class ProfilesApi extends BaseAPI {
    /**
     * Add work experience to a person
     * @summary Add Person Experience
     * @param {ProfilesApiAddPersonExperienceProfilesPeoplePersonIdExperiencesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public addPersonExperienceProfilesPeoplePersonIdExperiencesPost(requestParameters: ProfilesApiAddPersonExperienceProfilesPeoplePersonIdExperiencesPostRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).addPersonExperienceProfilesPeoplePersonIdExperiencesPost(requestParameters.personId, requestParameters.addPersonExperienceInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a canonical tag to a user profile
     * @summary Assign Profile Tag
     * @param {ProfilesApiAssignProfileTagProfilesCommunitiesCommunityIdTagsAssignPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost(requestParameters: ProfilesApiAssignProfileTagProfilesCommunitiesCommunityIdTagsAssignPostRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).assignProfileTagProfilesCommunitiesCommunityIdTagsAssignPost(requestParameters.communityId, requestParameters.assignProfileTagInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Block User
     * @param {ProfilesApiBlockUserProfilesUsersUserIdBlocksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public blockUserProfilesUsersUserIdBlocksPost(requestParameters: ProfilesApiBlockUserProfilesUsersUserIdBlocksPostRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).blockUserProfilesUsersUserIdBlocksPost(requestParameters.userId, requestParameters.blockedUserInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Create Profiles
     * @param {ProfilesApiBulkCreateProfilesProfilesUsersBulkCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public bulkCreateProfilesProfilesUsersBulkCreatePost(requestParameters: ProfilesApiBulkCreateProfilesProfilesUsersBulkCreatePostRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).bulkCreateProfilesProfilesUsersBulkCreatePost(requestParameters.bulkCreateProfilesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk Get Profile
     * @param {ProfilesApiBulkGetProfileProfilesUsersBulkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public bulkGetProfileProfilesUsersBulkPost(requestParameters: ProfilesApiBulkGetProfileProfilesUsersBulkPostRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).bulkGetProfileProfilesUsersBulkPost(requestParameters.bulkGetProfilesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check If Blocked
     * @param {ProfilesApiCheckIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet(requestParameters: ProfilesApiCheckIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).checkIfBlockedProfilesUsersUserIdBlocksBlockedUserIdGet(requestParameters.userId, requestParameters.blockedUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a canonical profile tag definition for a community
     * @summary Create Canonical Tag
     * @param {ProfilesApiCreateCanonicalTagProfilesCommunitiesCommunityIdTagsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public createCanonicalTagProfilesCommunitiesCommunityIdTagsPost(requestParameters: ProfilesApiCreateCanonicalTagProfilesCommunitiesCommunityIdTagsPostRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).createCanonicalTagProfilesCommunitiesCommunityIdTagsPost(requestParameters.communityId, requestParameters.createCanonicalProfileTagInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new person enrichment record
     * @summary Create Person
     * @param {ProfilesApiCreatePersonProfilesPeoplePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public createPersonProfilesPeoplePost(requestParameters: ProfilesApiCreatePersonProfilesPeoplePostRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).createPersonProfilesPeoplePost(requestParameters.createPersonInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Profile
     * @param {ProfilesApiCreateProfileProfilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public createProfileProfilesPost(requestParameters: ProfilesApiCreateProfileProfilesPostRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).createProfileProfilesPost(requestParameters.createProfileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete a canonical profile tag
     * @summary Delete Canonical Tag
     * @param {ProfilesApiDeleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete(requestParameters: ProfilesApiDeleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).deleteCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdDelete(requestParameters.communityId, requestParameters.tagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft-delete a person\'s work experience
     * @summary Delete Person Experience
     * @param {ProfilesApiDeletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete(requestParameters: ProfilesApiDeletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).deletePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdDelete(requestParameters.personId, requestParameters.experienceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Blocked Users
     * @param {ProfilesApiGetBlockedUsersProfilesUsersUserIdBlocksGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public getBlockedUsersProfilesUsersUserIdBlocksGet(requestParameters: ProfilesApiGetBlockedUsersProfilesUsersUserIdBlocksGetRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).getBlockedUsersProfilesUsersUserIdBlocksGet(requestParameters.userId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all canonical tags for a community
     * @summary Get Canonical Tags
     * @param {ProfilesApiGetCanonicalTagsProfilesCommunitiesCommunityIdTagsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public getCanonicalTagsProfilesCommunitiesCommunityIdTagsGet(requestParameters: ProfilesApiGetCanonicalTagsProfilesCommunitiesCommunityIdTagsGetRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).getCanonicalTagsProfilesCommunitiesCommunityIdTagsGet(requestParameters.communityId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get person enrichment data by profile user_id
     * @summary Get Person By Profile
     * @param {ProfilesApiGetPersonByProfileProfilesProfilesUserIdPersonGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public getPersonByProfileProfilesProfilesUserIdPersonGet(requestParameters: ProfilesApiGetPersonByProfileProfilesProfilesUserIdPersonGetRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).getPersonByProfileProfilesProfilesUserIdPersonGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all work experiences for a person
     * @summary Get Person Experiences
     * @param {ProfilesApiGetPersonExperiencesProfilesPeoplePersonIdExperiencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public getPersonExperiencesProfilesPeoplePersonIdExperiencesGet(requestParameters: ProfilesApiGetPersonExperiencesProfilesPeoplePersonIdExperiencesGetRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).getPersonExperiencesProfilesPeoplePersonIdExperiencesGet(requestParameters.personId, requestParameters.currentOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get person enrichment data by person ID
     * @summary Get Person
     * @param {ProfilesApiGetPersonProfilesPeoplePersonIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public getPersonProfilesPeoplePersonIdGet(requestParameters: ProfilesApiGetPersonProfilesPeoplePersonIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).getPersonProfilesPeoplePersonIdGet(requestParameters.personId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Profile
     * @param {ProfilesApiGetProfileProfilesUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public getProfileProfilesUsersUserIdGet(requestParameters: ProfilesApiGetProfileProfilesUsersUserIdGetRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).getProfileProfilesUsersUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all profile tags assigned to a user by a specific community
     * @summary Get Profile Tags
     * @param {ProfilesApiGetProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet(requestParameters: ProfilesApiGetProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGetRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).getProfileTagsProfilesCommunitiesCommunityIdUsersUserIdTagsGet(requestParameters.communityId, requestParameters.userId, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for profiles by first and last name. Supports partial matches and pagination.
     * @summary Search Profiles
     * @param {ProfilesApiSearchProfilesProfilesSearchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public searchProfilesProfilesSearchPost(requestParameters: ProfilesApiSearchProfilesProfilesSearchPostRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).searchProfilesProfilesSearchPost(requestParameters.searchProfilesInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unassign a tag from a user profile
     * @summary Unassign Profile Tag
     * @param {ProfilesApiUnassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete(requestParameters: ProfilesApiUnassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).unassignProfileTagProfilesCommunitiesCommunityIdTagsAssignProfileTagIdDelete(requestParameters.communityId, requestParameters.profileTagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unblock User
     * @param {ProfilesApiUnblockUserProfilesUsersUserIdBlocksBlockedUserIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete(requestParameters: ProfilesApiUnblockUserProfilesUsersUserIdBlocksBlockedUserIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).unblockUserProfilesUsersUserIdBlocksBlockedUserIdDelete(requestParameters.userId, requestParameters.blockedUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a canonical profile tag
     * @summary Update Canonical Tag
     * @param {ProfilesApiUpdateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut(requestParameters: ProfilesApiUpdateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPutRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).updateCanonicalTagProfilesCommunitiesCommunityIdTagsTagIdPut(requestParameters.communityId, requestParameters.tagId, requestParameters.updateCanonicalProfileTagInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a person\'s work experience
     * @summary Update Person Experience
     * @param {ProfilesApiUpdatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut(requestParameters: ProfilesApiUpdatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPutRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).updatePersonExperienceProfilesPeoplePersonIdExperiencesExperienceIdPut(requestParameters.personId, requestParameters.experienceId, requestParameters.updatePersonExperienceInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update person enrichment data
     * @summary Update Person
     * @param {ProfilesApiUpdatePersonProfilesPeoplePersonIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public updatePersonProfilesPeoplePersonIdPut(requestParameters: ProfilesApiUpdatePersonProfilesPeoplePersonIdPutRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).updatePersonProfilesPeoplePersonIdPut(requestParameters.personId, requestParameters.updatePersonInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Photo
     * @param {ProfilesApiUpdatePhotoProfilesUsersUserIdPhotosPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public updatePhotoProfilesUsersUserIdPhotosPut(requestParameters: ProfilesApiUpdatePhotoProfilesUsersUserIdPhotosPutRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).updatePhotoProfilesUsersUserIdPhotosPut(requestParameters.userId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Profile Links
     * @param {ProfilesApiUpdateProfileLinksProfilesUsersUserIdLinksPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public updateProfileLinksProfilesUsersUserIdLinksPut(requestParameters: ProfilesApiUpdateProfileLinksProfilesUsersUserIdLinksPutRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).updateProfileLinksProfilesUsersUserIdLinksPut(requestParameters.userId, requestParameters.updateProfileLinksInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Profile
     * @param {ProfilesApiUpdateProfileProfilesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public updateProfileProfilesPut(requestParameters: ProfilesApiUpdateProfileProfilesPutRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).updateProfileProfilesPut(requestParameters.updateProfileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Video
     * @param {ProfilesApiUpdateVideoProfilesUsersUserIdVideosPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    public updateVideoProfilesUsersUserIdVideosPut(requestParameters: ProfilesApiUpdateVideoProfilesUsersUserIdVideosPutRequest, options?: RawAxiosRequestConfig) {
        return ProfilesApiFp(this.configuration).updateVideoProfilesUsersUserIdVideosPut(requestParameters.userId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



